<template>
  <div>
    <v-card v-if="list_access" class="mb-5 px-4 py-6">
      <div class="row">
        <div class="col-md-3">
          <v-autocomplete v-model="legajo_id" :items="legajos" :item-text="legajoLabel" item-value="id" label="Legajo"
            :loading="loading_legajos" clearable hide-details outlined dense></v-autocomplete>
        </div>
        <div class="col-md ps-filter">
          <v-select v-model="period_year" :items="years" label="Año" clearable hide-details outlined dense></v-select>
        </div>
        <div class="col-md ps-filter">
          <v-select v-model="period_month" :items="months" item-text="name" item-value="id" label="Mes" clearable
            hide-details outlined dense></v-select>
        </div>
        <div class="col-md ps-filter">
          <v-select v-model="type" :items="types" item-text="name" item-value="id" label="Tipo" clearable hide-details
            outlined dense></v-select>
        </div>
        <div class="col-md ps-filter">
          <v-select v-model="status" :items="statuses" item-text="name" item-value="id" label="Estado" clearable
            hide-details outlined dense></v-select>
        </div>
        <div class="col-md-auto ml-auto" style="display: flex; justify-content: end; align-items: center">
          <v-btn color="primary" @click="loadList(service)">Buscar</v-btn>
        </div>
      </div>
    </v-card>

    <div v-if="list_access" class="lc-loose">
      <div class="lc-toolbar">
        <v-simple-checkbox v-if="update_access" :value="allSelected" :indeterminate="someSelected" :disabled="selectable.length == 0"
          :ripple="false" class="mr-2" @input="toggleAll"></v-simple-checkbox>
        <template v-if="selected.length == 0">
          <span class="text-uppercase">Recibos</span>
        </template>
        <template v-else>
          <span class="mr-1" style="font-size: 16px">{{ selected.length }} seleccionados</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on">
                <v-icon class="grey--text text--darken-2">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="dialog_publish_many = true">
                <v-list-item-icon class="mr-3"><v-icon small color="primary">mdi-send</v-icon></v-list-item-icon>
                <v-list-item-title>Publicar</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="selectedPayslips.some((p) => p.scheduled_publish_at && p.status == draft)"
                @click="openCancelSchedule(selectedPayslips)">
                <v-list-item-icon class="mr-3"><v-icon small color="purple">mdi-calendar-remove</v-icon></v-list-item-icon>
                <v-list-item-title>Cancelar programación</v-list-item-title>
              </v-list-item>
              <v-list-item @click="dialog_void_many = true">
                <v-list-item-icon class="mr-3"><v-icon small color="red">mdi-cancel</v-icon></v-list-item-icon>
                <v-list-item-title class="red--text">Anular</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="selected = []">
                <v-list-item-icon class="mr-3"><v-icon small>mdi-close</v-icon></v-list-item-icon>
                <v-list-item-title>Quitar selección</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" class="lc-toolbar__search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      </div>
      <v-data-iterator :items="loading ? [] : list" :search="search" :custom-filter="filterPayslips" :loading="loading"
        :hide-default-footer="loading" :items-per-page="15" :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }">
        <template v-slot:loading>
          <ListSkeletonRows :count="6" avatar />
        </template>
        <template v-slot:default="props">
          <div class="lc-list">
            <div v-for="payslip in props.items" :key="payslip.id" class="lc-item ps-row"
              :class="{ 'lc-item--muted': payslip.status == voided }">
              <div class="lc-main ps-main">
                <div v-if="update_access" @click.stop>
                  <v-simple-checkbox :value="selected.includes(payslip.id)" :disabled="payslip.status == voided" :ripple="false"
                    @input="toggle(payslip)"></v-simple-checkbox>
                </div>
                <div class="lc-icon-box lc-icon-box--round">{{ legajoInitials(payslip.legajo) }}</div>
                <div class="lc-info">
                  <div class="lc-title">{{ payslip.legajo ? payslip.legajo.surname + ", " + payslip.legajo.name : "Sin asignar" }}</div>
                  <div class="lc-sub">
                    <span v-if="payslip.legajo">Legajo {{ payslip.legajo.nro_legajo }}</span>
                    <span v-if="payslip.legajo && payslip.legajo.cuil"> · CUIL {{ payslip.legajo.cuil }}</span>
                  </div>
                </div>
              </div>
              <div class="lc-meta">
                <div class="lc-meta-col ps-col-period">
                  {{ periodTitle(payslip) }}
                  <small>{{ payslip.type ? payslip.type.name : "" }}</small>
                </div>
                <div class="lc-meta-col ps-col-payment">
                  Pago {{ formatDate(payslip.payment_date) }}
                  <small>{{ payslip.batch_id ? "Carga masiva" : "Carga individual" }}</small>
                </div>
                <div class="ps-col-email">
                  <PayslipEmailStatus :payslip="payslip" />
                </div>
                <div class="ps-col-status">
                  <v-tooltip bottom :disabled="!statusTooltip(payslip)">
                    <template v-slot:activator="{ on }">
                      <v-chip v-on="on" small :color="payslipStatus(payslip).color" :text-color="payslipStatus(payslip).text_color">
                        {{ payslipStatus(payslip).name }}
                      </v-chip>
                    </template>
                    <span>{{ statusTooltip(payslip) }}</span>
                  </v-tooltip>
                </div>
                <PayslipActions class="ps-col-actions" :payslip="payslip" :update_access="update_access" @preview="openPreview" @assign="openAssign"
                  @signature="openSignature" @publish="openPublish" @cancel-schedule="(item) => openCancelSchedule([item])" @events="openEvents" @void="openVoid" />
              </div>
            </div>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="lc-empty">No hay recibos para los filtros seleccionados.</div>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning" class="ma-4">
            {{ "Busqueda sin resultados - " + search }}
          </v-alert>
        </template>
      </v-data-iterator>
    </div>

    <ModalSignPayslip :dialog="dialog_signature" :payslip="selected_payslip" :signature-loader="signatureLoader"
      @updateDialog="(value) => (dialog_signature = value)" />
    <ModalPayslipEvents :dialog="dialog_events" :payslip="selected_payslip" @updateDialog="(value) => (dialog_events = value)" />
    <ModalAssignLegajo :dialog="dialog_assign" :payslip="selected_payslip" @updateDialog="(value) => (dialog_assign = value)"
      @preview="openPreview" @saved="loadList(service)" />
    <ModalPublishPayslips :dialog="dialog_publish" :payslips="publish_payslips" @updateDialog="(value) => (dialog_publish = value)"
      @saved="onBulkSaved" />
    <ModalPublishPayslips :dialog="dialog_publish_many" :payslips="selectedPayslips"
      @updateDialog="(value) => (dialog_publish_many = value)" @saved="onBulkSaved" />
    <ModalVoidPayslip :dialog="dialog_void" :payslip="selected_payslip" @updateDialog="(value) => (dialog_void = value)"
      @saved="loadList(service)" />
    <ModalVoidPayslips :dialog="dialog_void_many" :payslips="selectedPayslips" @updateDialog="(value) => (dialog_void_many = value)"
      @saved="onBulkSaved" />
    <DialogYesNo :open="dialog_cancel_schedule" title="Cancelar programación" :message="cancelScheduleMessage" :loading="loading_cancel"
      :maxWidth="450" nameCancel="Volver" nameAccept="Cancelar programación" @cancel="dialog_cancel_schedule = false"
      @accept="cancelSchedule" />
  </div>
</template>

<script>
import { payslipService } from "@/libs/ws/payslipService";
import { legajoService } from "@/libs/ws/legajoService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";
import PayslipActions from "./PayslipActions.vue";
import PayslipEmailStatus from "./PayslipEmailStatus.vue";
import ModalPublishPayslips from "./ModalPublishPayslips.vue";
import { openPdfInNewTab } from "@/libs/utils/pdfTab";
import ModalPayslipEvents from "./ModalPayslipEvents.vue";
import ModalAssignLegajo from "./ModalAssignLegajo.vue";
import ModalVoidPayslip from "./ModalVoidPayslip.vue";
import ModalVoidPayslips from "./ModalVoidPayslips.vue";
import ListSkeletonRows from "@/components/ListSkeletonRows.vue";
import ModalSignPayslip from "@/views/MyPayslips/ModalSignPayslip.vue";
import {
  PAYSLIP_TYPES,
  PAYSLIP_STATUSES,
  PAYSLIP_STATUS_DRAFT,
  PAYSLIP_STATUS_VOIDED,
  PAYSLIP_STATUS_SIGNED,
  PAYSLIP_FILTER_SCHEDULED,
  PAYSLIP_SCHEDULED_CHIP,
  MONTHS,
  periodTitle,
  legajoLabel,
  legajoInitials,
  filterPayslips,
  yearOptions,
  formatDate,
  formatDateTime,
  signedChip,
} from "@/constants/payslips";

export default {
  components: {
    DialogYesNo,
    PayslipActions,
    PayslipEmailStatus,
    ModalPublishPayslips,
    ModalPayslipEvents,
    ModalAssignLegajo,
    ModalVoidPayslip,
    ModalVoidPayslips,
    ListSkeletonRows,
    ModalSignPayslip,
  },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      service: payslipService,
      mainItem: {},
      defaultItem: {},
      legajo_id: null,
      period_year: null,
      period_month: null,
      type: null,
      status: null,
      legajos: [],
      loading_legajos: false,
      years: yearOptions(),
      months: MONTHS,
      types: PAYSLIP_TYPES,
      statuses: Object.keys(PAYSLIP_STATUSES)
        .map((id) => ({ id, name: PAYSLIP_STATUSES[id].name }))
        .concat([{ id: PAYSLIP_FILTER_SCHEDULED, name: PAYSLIP_SCHEDULED_CHIP.name }]),
      draft: PAYSLIP_STATUS_DRAFT,
      voided: PAYSLIP_STATUS_VOIDED,
      // Ids de los recibos tildados para las acciones masivas
      selected: [],
      selected_payslip: null,
      publish_payslips: [],
      cancel_payslips: [],
      dialog_events: false,
      dialog_signature: false,
      signatureLoader: payslipService.signature,
      dialog_assign: false,
      dialog_void: false,
      dialog_publish: false,
      dialog_publish_many: false,
      dialog_void_many: false,
      dialog_cancel_schedule: false,
      loading_cancel: false,
      periodTitle: periodTitle,
      legajoLabel: legajoLabel,
      legajoInitials: legajoInitials,
      filterPayslips: filterPayslips,
      formatDate: formatDate,
    };
  },
  computed: {
    // Recibos que se pueden tildar: los del listado (con el buscador aplicado) que no estan anulados
    selectable() {
      return filterPayslips(this.list, this.search).filter((payslip) => payslip.status != PAYSLIP_STATUS_VOIDED);
    },
    selectedPayslips() {
      return this.list.filter((payslip) => this.selected.includes(payslip.id));
    },
    allSelected() {
      return this.selectable.length > 0 && this.selectable.every((payslip) => this.selected.includes(payslip.id));
    },
    someSelected() {
      return this.selected.length > 0 && !this.allSelected;
    },
    cancelScheduleMessage() {
      const count = this.cancel_payslips.length;
      return count == 1
        ? "¿Cancelar la publicación programada del recibo? Queda en borrador."
        : "¿Cancelar la publicación programada de " + count + " recibos? Quedan en borrador.";
    },
  },
  watch: {
    // Al recargar el listado se descartan los tildados que ya no estan
    list(items) {
      const ids = items.map((payslip) => payslip.id);
      this.selected = this.selected.filter((id) => ids.includes(id));
    },
  },
  mounted() {
    this.loadLegajos();
    this.loadList(this.service);
  },
  methods: {
    getFilterParams() {
      return {
        legajo_id: this.legajo_id,
        period_year: this.period_year,
        period_month: this.period_month,
        type: this.type,
        status: this.status,
      };
    },
    loadLegajos() {
      this.loading_legajos = true;
      legajoService
        .filter({ status: "all" })
        .then((response) => {
          if (response.status) this.legajos = response.result;
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading_legajos = false));
    },
    payslipStatus(item) {
      if (item.status == PAYSLIP_STATUS_DRAFT && item.scheduled_publish_at) return PAYSLIP_SCHEDULED_CHIP;
      if (item.status == PAYSLIP_STATUS_SIGNED) return signedChip(item);
      return PAYSLIP_STATUSES[item.status] || { name: item.status };
    },
    statusTooltip(item) {
      if (item.status == PAYSLIP_STATUS_DRAFT && item.scheduled_publish_at) return "Se publica el " + formatDateTime(item.scheduled_publish_at);
      if (item.status == PAYSLIP_STATUS_SIGNED)
        return "Firmado el " + formatDateTime(item.signed_at) + (item.disagreement_reason ? " · Motivo: " + item.disagreement_reason : "");
      return item.void_reason;
    },
    toggle(payslip) {
      if (this.selected.includes(payslip.id)) this.selected = this.selected.filter((id) => id != payslip.id);
      else this.selected = this.selected.concat([payslip.id]);
    },
    toggleAll() {
      this.selected = this.allSelected ? [] : this.selectable.map((payslip) => payslip.id);
    },
    onBulkSaved() {
      this.selected = [];
      this.loadList(this.service);
    },
    // Abre el PDF en otra pestaña (el firmado si el empleado ya lo firmo)
    openPreview(item) {
      openPdfInNewTab(payslipService.file(item.id))
        .then((response) => {
          if (!response.status) this.$toast.error(response.msg, "Error");
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("No se pudo abrir el recibo.", "Error");
        });
    },
    // Firma del empleado (solo lectura)
    openSignature(item) {
      this.selected_payslip = item;
      this.dialog_signature = true;
    },
    openAssign(item) {
      this.selected_payslip = item;
      this.dialog_assign = true;
    },
    openPublish(item) {
      this.publish_payslips = [item];
      this.dialog_publish = true;
    },
    openEvents(item) {
      this.selected_payslip = item;
      this.dialog_events = true;
    },
    openVoid(item) {
      this.selected_payslip = item;
      this.dialog_void = true;
    },
    openCancelSchedule(items) {
      this.cancel_payslips = items.filter((payslip) => payslip.status == PAYSLIP_STATUS_DRAFT && payslip.scheduled_publish_at);
      this.dialog_cancel_schedule = true;
    },
    cancelSchedule() {
      if (this.loading_cancel) return;
      this.loading_cancel = true;
      payslipService
        .cancel_schedule({ ids: this.cancel_payslips.map((payslip) => payslip.id) })
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.dialog_cancel_schedule = false;
            this.onBulkSaved();
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("Ocurrió un error al cancelar la programación.", "Error");
        })
        .finally(() => (this.loading_cancel = false));
    },
  },
};
</script>

<style scoped>
/* Columnas de ancho fijo para que los datos queden alineados entre filas */
.ps-row {
  flex-wrap: wrap;
}
/* Si el nombre no llega a este ancho, los datos pasan a un segundo renglón */
.ps-main {
  flex: 1 1 300px;
}
.ps-row .lc-meta {
  flex: 0 1 auto;
  flex-wrap: wrap;
  min-width: 0;
}
/* Si no entran en una línea, los filtros pasan al renglón siguiente */
.ps-filter {
  min-width: 150px;
}
/* Periodo y pago alineados a la izquierda dentro de su columna */
/* Ancho para "2da quincena · Septiembre 2026" en una sola línea */
.ps-col-period {
  width: 190px;
  text-align: left;
  white-space: nowrap;
}
.ps-col-payment {
  width: 125px;
  text-align: left;
}
.ps-col-email {
  width: 20px;
  display: flex;
  justify-content: center;
}
/* Ancho para "Firmado · Disconforme" sin cortar */
.ps-col-status {
  width: 200px;
  display: flex;
  justify-content: flex-start;
}
.ps-col-status .v-chip {
  white-space: nowrap;
}
.ps-col-actions {
  width: 90px;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .ps-main {
    flex: none;
  }
  .ps-col-period,
  .ps-col-payment,
  .ps-col-status,
  .ps-col-actions {
    width: auto;
  }
}
</style>
